export const DAO_CODE = 'DASHBOARD_CODEV' + '_DAO';
